import Component from '../colorz/Component';
import device from '../colorz/utils/device';

module.exports = class MobileMenu extends Component {
  onInit( el, args) {
    // Initializations
    this.onToggle = this.onToggle.bind( this );
    this.onScroll = this.onScroll.bind( this );

    this.el     = el;
    this.btn    = this.el.querySelector('.js-open-mobile-menu');
    this.header = this.el.querySelector('.header__mobile');
    this.logo   = this.el.querySelector('.logo');
    this.isOpen = false;
  }

  onReady() {
    // for header purpose
    if ( window.matchMedia("(max-width: 1080px)").matches ) {
      document.body.classList.add('mobile');

      if ( !document.body.classList.contains('home') ) {
        document.body.style.paddingTop = this.el.offsetHeight +'px';
      }
    }

    this.btn.addEventListener( device.pointerdown, this.onToggle );
  }

  onToggle() {
    if( this.isOpen ) {
      this.close();
    }
    else {
      this.open();
    }
  }

  onScroll() {
    if ( document.body.classList.contains('home') && this.el.offsetHeight <= device.scroll.top && this.el.classList.contains('white') ) {
      this.el.classList.add('bgVariant--black');
    } else if ( document.body.classList.contains('home') && this.el.offsetHeight <= device.scroll.top && this.el.classList.contains('black') ) {
      this.el.classList.add('bgVariant--white');
    } else if ( document.body.classList.contains('home') && this.el.offsetHeight >= device.scroll.top ) {
      this.el.classList.remove('bgVariant--white');
      this.el.classList.remove('bgVariant--black');
    } else {
      return;
    }
  }

  open(){
    document.body.classList.add('menu-is-active');
    this.header.style.display = 'block';

    requestAnimationFrame( () => {
      this.header.classList.add('is-fade-in');
    });

    this.isOpen = true;
  }

  close(){
    this.header.classList.remove('is-fade-in');
    document.body.classList.remove('menu-is-active');

    this.header.style.display = 'none';

    this.isOpen = false;
  }
}